<template>
  <div  v-visible-track="'Iframe.ancientDnaSampleDatabasePageViewed'">
    <div class="sample-database" v-if="$store.state.appConfig.windowWidth >= 769">
      <div class="result-container">
        <SampleDatabaseSidebar />
      </div>
      <div class="samples-container">
        <AncientSampleList v-if="selectedSampleType === 'ANCIENT'"/>
        <AncientIndividualSampleList v-if="selectedSampleType === 'ANCIENT-INDIVIDUAL'"/>
        <ModernSampleList v-if="selectedSampleType === 'MODERN'"/>
      </div>
    </div>

    <div class="pca-plots-mobile" v-else>
      <SampleDatabaseSidebar />
      <AncientSampleList v-if="selectedSampleType === 'ANCIENT'"/>
      <AncientIndividualSampleList v-if="selectedSampleType === 'ANCIENT-INDIVIDUAL'"/>
      <ModernSampleList v-if="selectedSampleType === 'MODERN'"/>
    </div>
  </div>
</template>

<script>
import SampleDatabaseWatcher from './services/SampleDatabaseWatcher';
import SampleDatabaseCalculatorWatcher from './services/SampleDatabaseCalculatorWatcher';

import SampleDatabaseSidebar from './sidebar/SampleDatabaseSidebar.vue';
import AncientSampleList from './samples-list/ancient/AncientSampleList.vue';
import AncientIndividualSampleList from './samples-list/ancient-individual/AncientIndividualSampleList.vue'
import ModernSampleList from './samples-list/modern/ModernSampleList.vue';

export default {
  components: {
    SampleDatabaseSidebar,
    AncientSampleList,
    AncientIndividualSampleList,
    ModernSampleList,
  },
  data() {
    return {
    };
  },
  computed: {
    selectedSampleType() {
      return this.$store.state.sampleDatabase.selectedSampleType
    },
  },
  methods: {
  },
  mounted() {
    SampleDatabaseWatcher.init()
    SampleDatabaseCalculatorWatcher.init()
  },
  beforeDestroy() {
    SampleDatabaseWatcher.cleanup();
    SampleDatabaseCalculatorWatcher.cleanup();
  },
};
</script>

<style lang="scss" scoped>
.sample-database {
  width: 100%;
  display: flex;

  .result-container {
    z-index: 1;
    position: relative;
    width: 30%;
    display: flex;
    flex-direction: column;
    height: 100vh;
  }
  .samples-container {
    width: 70%;
    flex-grow: 1;
    height: auto;
    position: relative;
  }
}
</style>